function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2049.306,246.845v35.046h35.046V246.845Zm31.541,31.541h-28.036V275.5l6.269-6.017,6.058,6.017.046-.026.036.026,9.662-9.823,5.965,6.126Zm0-12.266-5.807-5.495-9.837,9.931-6.073-6.166-6.319,6.155v-20.2h28.036Zm-6.585-9.692a1.752,1.752,0,1,1,1.752,1.752A1.751,1.751,0,0,1,2074.262,256.428Z",
  transform: "translate(-2049.306 -246.845)",
  fill: "gray"
});

var SvgNoImg = function SvgNoImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35.046,
    height: 35.046,
    viewBox: "0 0 35.046 35.046",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-img.fc431801.svg";
export { ForwardRef as ReactComponent };